/**
 * Configuration Service
 * Handles loading and providing access to the application config.json
 */

let appConfig = null;

/**
 * Fetches the config.json file from the public/config directory
 * This should be called once on app initialization
 */
export const loadConfig = async () => {
  if (appConfig) {
    return appConfig;
  }

  try {
    const response = await fetch('/config/config.json');
    if (!response.ok) {
      throw new Error(`Failed to load config: ${response.statusText}`);
    }
    appConfig = await response.json();
    return appConfig;
  } catch (error) {
    console.error('Error loading configuration:', error);
    throw error;
  }
};

/**
 * Retrieves the cached config
 * Make sure loadConfig() has been called first
 */
export const getConfig = () => {
  if (!appConfig) {
    throw new Error('Config not loaded. Call loadConfig() first.');
  }
  return appConfig;
};

/**
 * Retrieves auth configuration
 */
export const getAuthConfig = () => {
  const config = getConfig();
  return config.auth;
};

/**
 * Retrieves API base URL
 */
export const getApiBaseUrl = () => {
  const config = getConfig();
  return config.api.baseUrl;
};
